import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import TruncateMarkup from 'react-truncate-markup';

import { slugify } from '../../../helpers/view';

import c from './ArtistCard.less';

function ArtistCard({ artist, history }) {
  const handleLinkClick = (e) => {
    e.preventDefault();
    const url = new URL(e.target.href);

    history.push(url.pathname);
  };

  return (
    <div className={c.artistCard}>
      <div className={c.cover}>
        <Link to={`/artist/${slugify(artist.name, artist.id)}`}>
          <img
            src={`${artist.coverUrl}/230.jpg`}
            alt={`${artist.name} Music Discography`}
          />
        </Link>
      </div>
      <div className={c.info}>
        <h4>
          <TruncateMarkup lines={2}>
            <a
              href={`/artist/${slugify(artist.name, artist.id)}`}
              onClick={handleLinkClick}
            >
              {artist.name}
            </a>
          </TruncateMarkup>
        </h4>
      </div>
    </div>
  );
}

ArtistCard.propTypes = {
  artist: PropTypes.object.isRequired,
};

export default withRouter(ArtistCard);
